class TCPassengerUIModel {
  constructor({
    ancillaries = [],
    id = null,
    isMultipleTickets = null,
    isWheelChair = null,
    passengerDetails = {},
    passengerInfant = '',
    passengerInfo = {},
    passengerNameNumber = '',
    priorityCode = '',
    seats = [],
    ssrs = [],
    ticketInfo = {},
    upgradeCode = '',
  } = {}) {
    this.ancillaries = ancillaries;
    this.id = id;
    this.isMultipleTickets = isMultipleTickets;
    this.isWheelChair = isWheelChair;
    this.passengerDetails = passengerDetails;
    this.passengerInfant = passengerInfant;
    this.passengerInfo = passengerInfo;
    this.passengerNameNumber = passengerNameNumber;
    this.priorityCode = priorityCode;
    this.seats = seats;
    this.ssrs = ssrs;
    this.ticketInfo = ticketInfo;
    this.upgradeCode = upgradeCode;
  }
}

export default TCPassengerUIModel;